module.exports = __webpack_public_path__ + "media/images/landing/en/manage-ed7020abce52e64c2e2441e1c9bd6d5b.png";